module.exports = __webpack_public_path__ + "static/media/Matlandia8_przewodnik_po_zadaniach.67c624c8.pdf";